module.exports = "/_next/static/images/b7ddbd473cd1ce868f25c24dc180473d-apple-pay-lg.png.webp";